(function () {
  const TIMEOUT_MS = 30 * 60 * 1000;   // 30 minutes
  const WARN_BEFORE_MS = 30 * 1000;    // warn 30 seconds before expiry

  const modal = document.getElementById('session-warning');
  const countdown = document.getElementById('session-countdown');
  const extendBtn = document.getElementById('extend-session-btn');

  if (!modal || !extendBtn) return;

  let warnTimer, expireTimer, countdownInterval;

  function autoSave() {
    const data = {};
    document.querySelectorAll('form input, form textarea, form select').forEach(function (el) {
      if (el.name) data[el.name] = el.value;
    });
    localStorage.setItem('session_autosave', JSON.stringify(data));
  }

  function restoreData() {
    var saved = localStorage.getItem('session_autosave');
    if (!saved) return;
    var data = JSON.parse(saved);
    Object.entries(data).forEach(function ([name, value]) {
      var el = document.querySelector('[name="' + name + '"]');
      if (el) el.value = value;
    });
    localStorage.removeItem('session_autosave');
  }

  function showWarning() {
    var secs = 30;
    countdown.textContent = secs;
    modal.style.display = 'flex';
    modal.focus();
    countdownInterval = setInterval(function () {
      secs--;
      countdown.textContent = secs;
      if (secs <= 0) clearInterval(countdownInterval);
    }, 1000);
  }

  function hideWarning() {
    modal.style.display = 'none';
    clearInterval(countdownInterval);
  }

  function handleExpiry() {
    autoSave();
    hideWarning();
  }

  function resetTimers() {
    clearTimeout(warnTimer);
    clearTimeout(expireTimer);
    hideWarning();
    warnTimer = setTimeout(showWarning, TIMEOUT_MS - WARN_BEFORE_MS);
    expireTimer = setTimeout(handleExpiry, TIMEOUT_MS);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') resetTimers();
  });

  extendBtn.addEventListener('click', resetTimers);

  ['click', 'keypress', 'mousemove', 'scroll'].forEach(function (evt) {
    document.addEventListener(evt, resetTimers, { passive: true });
  });

  restoreData();
  resetTimers();
})();